type Education = { label: string; value: string }
type Year = { value: number; label: string }

export const DEGREE_TYPES: Array<Education> = [
  { label: 'High School Diploma', value: 'HIGH_SCHOOL_DIPLOMA' },
  { label: 'Some college, no degree', value: 'SOME_COLLEGE' },
  { label: 'Associates degree', value: 'ASSOCIATES' },
  { label: "Bachelor's degree", value: 'BACHELORS' },
  { label: "Master's degree", value: 'MASTERS' },
  { label: 'PhD', value: 'PHD' },
  { label: 'Other', value: 'OTHER' },
]
const getYearDropdownOptions = (startYear: number, endYear: number) => {
  const yearDropdownOptions: Year[] = []
  for (let i = startYear; i <= endYear; i++) {
    yearDropdownOptions.push({ value: i, label: String(i) })
  }
  return yearDropdownOptions
}

export const getPast50years = () => {
  const currentYear = new Date().getFullYear()
  const startYear = currentYear - 50
  return getYearDropdownOptions(startYear, currentYear)
}

export const getPastNYears = (n = 0) => {
  const currentYear = new Date().getFullYear()
  const startYear = currentYear - n
  return getYearDropdownOptions(startYear, currentYear)
}

// we only care about the year of graduation, to ensure the date we save is the correct year we set the month/day/time to the approx middle of the calendar year (ie, July 2nd @ noon)
export const MIDDLE_OF_CALENDAR_YEAR = '07-02 12:00:00'
